module.exports = __webpack_public_path__ + "static/media/Avatars_Male-07.4f684a9c.png";